import _Drawer from './Drawer';

import './style/index.js';

export type { DrawerProps } from './Drawer';
export * from './type';

export const Drawer = _Drawer;
export default Drawer;
